import redirectWhenUnauthenticated from "@/service/redirect-when-unauthenticated";

/**
 * Files
 */
export default [
  {
    path: "/files",
    component: () =>
      import(/* webpackChuckName: "common" */ "@/views/layout/Overview.vue"),
    beforeEnter: redirectWhenUnauthenticated("login", "unauthorized", [
      "hd_reprocessing"
    ]),
    props: {
      title: "files.title"
    },
    children: [
      {
        path: "overview/:filter?/:value?",
        name: "files-overview",
        props: true,
        component: () =>
          import(/* webpackChunkName: "files" */ "@/views/files/Files.vue")
      },
      {
        path: "exporter/:folderId?/:fileUuid?",
        name: "files-exporter",
        props: true,
        component: () =>
          import(/* webpackChunkName: "files" */ "@/views/files/Exporter.vue")
      }
    ]
  }
];
